import { FullFormAction } from "../../../Core/Store/FullFormAction";
import { RequisitesInfo } from "../../../Form/IForm";

import { RequisitesActionType } from "./RequisitesActions";

export const defaultRequisitesState = {};

export function requisitesReducer(state = defaultRequisitesState, action: FullFormAction): RequisitesInfo {
    switch (action.type) {
        case RequisitesActionType.LoadInitialRequisites: {
            return action.payload;
        }
        default: {
            return state;
        }
    }
}
